import React from "react";
import NotFoundPageContent from "../components/organisms/NotFoundPageContent";
import { MoreDetailTemplates } from "../components/template/MoreDetailTemplates";

const NotFoundPage = (props: any) => (
  <>
    <MoreDetailTemplates isBack={true} pageTitle="페이지 준비 중">
      {/* <Navbar title="페이지 준비중" backLink="Back" /> */}
      {/* <Block strong inset> */}
      <NotFoundPageContent contentText="페이지 준비 중입니다." />
    </MoreDetailTemplates>
    {/* </Block> */}
  </>
);

export default NotFoundPage;
